import pulseCircle from './images/plus-circle.svg';
import pluseWhite from './images/Icon-Expand.svg';
import whiteChecked from './images/check-white.svg';
import close from './images/Icon-Cancel.svg';
import search from './images/Icon_search.svg';
import info_icon from './images/Icon_info.svg';
import info_more_icon from './images/Icon_More_info.svg';
import calender_icon from './images/icon_calander.svg';
import external_link from './images/Icon_external_link.svg';
import add_doc from './images/add-document.svg';
import delete_icon from './images/deletedrayage.svg';

const Images = {
  pulseCircle,
  pluseWhite,
  whiteChecked,
  close,
  search,
  info_icon,
  info_more_icon,
  calender_icon,
  external_link,
  add_doc,
  delete_icon
}

export default Images;